module.exports = __webpack_public_path__ + "img/un.0f74c2f2.svg";